export const environment = {
  production: false,
  baseUrl: 'https://validador-dev.afpcapital.cl/api/bff',
};
